export const MODEL_TYPE_OPTIONS = [
  {
    label: "聊天",
    value: "聊天",
  },
  {
    label: "AI任务",
    value: "AI任务",
  },
];

export const MODEL_TYPE_ALL_SEARCH_OPTION = {
  title: "全部分类",
  value: "",
};

export const MODEL_TYPE_INPUT_STYLE = {
  width: "100%",
  minWidth: 180,
};

export const MODEL_FORM_LAYOUT = {
  layout: "vertical",
};

export const MODEL_MODAL_WIDTH = 660;

export const CHARGE_RULE_TEXTAREA_STYLE = {
  height: 100,
  resize: "none",
};

const MODEL_PRICE_RATIO = 1000000;

const MODEL_MAIN_LIST_COLUMN_KEYS = [
  "model",
  "description",
  "modelType",
  "bm",
  "sort",
  "tokens",
  "userIds",
  "enableStatus",
  "updateTime",
  "action",
];

const MODEL_KEY_LIST_COLUMN_KEYS = [
  "endpoint",
  "api_key",
  "weight",
  "tokens",
  "action",
];

export function getModelMainListColumnKeys() {
  return [...MODEL_MAIN_LIST_COLUMN_KEYS];
}

export function getModelKeyListColumnKeys() {
  return [...MODEL_KEY_LIST_COLUMN_KEYS];
}

export function getModelSubmitterLoading(submitterProps = {}) {
  return Boolean(
    submitterProps?.submitButtonProps?.loading ||
    submitterProps?.loading ||
    submitterProps?.submitting
  );
}

export function getModelPageAfterDelete(page, currentPageItemCount) {
  const currentPage = Number(page) || 1;
  const itemCount = Number(currentPageItemCount) || 0;
  if (currentPage > 1 && itemCount <= 1) {
    return currentPage - 1;
  }
  return currentPage;
}

export function sumModelKeyTokens(modelKeys = []) {
  const rows = Array.isArray(modelKeys) ? modelKeys : [];
  return rows.reduce((total, item) => {
    const tokenCount = Number(item?.tokens);
    if (Number.isFinite(tokenCount)) {
      return total + tokenCount;
    }
    const promptTokens = Number(item?.promptTokens);
    const completionTokens = Number(item?.completionTokens);
    return (
      total +
      (Number.isFinite(promptTokens) ? promptTokens : 0) +
      (Number.isFinite(completionTokens) ? completionTokens : 0)
    );
  }, 0);
}

export function isModelEnabled(enableStatus) {
  return Number(enableStatus) === 1;
}

export function getModelStatusText(enableStatus) {
  return isModelEnabled(enableStatus) ? "启用" : "停用";
}

export function getNextModelEnableStatus(enableStatus) {
  return isModelEnabled(enableStatus) ? 2 : 1;
}

export function getModelListActionTypes(enableStatus) {
  return isModelEnabled(enableStatus)
    ? ["key", "toggle", "edit"]
    : ["key", "toggle", "edit", "delete"];
}

export function buildModelGroupPayload(values = {}, modelGroupId) {
  const payload = {
    modelType: values.modelType || "",
    bm: values.bm || values.modelType || "",
    description: values.description || "",
  };
  if (modelGroupId) {
    payload._id = modelGroupId;
  }
  return payload;
}

const MODEL_TYPE_TEXT = {
  CHAT: "聊天",
  chat: "聊天",
  AI_TASK: "AI任务",
  AI_TASKS: "AI任务",
  aiTask: "AI任务",
  TASK: "AI任务",
  task: "AI任务",
};

export function getModelDisplayName(record = {}) {
  return (
    record.modelName ||
    record.name ||
    record.model ||
    record.modelType ||
    "-"
  );
}

export function getModelLogoUrl(record = {}) {
  return (
    record.modelLogo ||
    record.logoUrl ||
    record.logo ||
    record.iconUrl ||
    ""
  );
}

export function getModelTypeText(value) {
  return MODEL_TYPE_TEXT[value] || value || "-";
}

export function getModelTypeOptions(currentValue, modelGroups = []) {
  const optionSet = new Set();
  const options = modelGroups.length
    ? modelGroups
      .filter((item) => {
        if (!item?.modelType || optionSet.has(item.modelType)) {
          return false;
        }
        optionSet.add(item.modelType);
        return true;
      })
      .map((item) => ({
        label: item.modelType,
        value: item.modelType,
      }))
    : [...MODEL_TYPE_OPTIONS];
  if (
    currentValue &&
    !options.some((item) => item.value === currentValue)
  ) {
    options.push({
      label: currentValue,
      value: currentValue,
    });
  }
  return options;
}

export function getModelTypeSearchOptions(modelGroups = []) {
  const source = Array.isArray(modelGroups) && modelGroups.length
    ? modelGroups
    : MODEL_TYPE_OPTIONS.map((item) => ({
      modelType: item.value,
    }));
  const optionSet = new Set();
  const options = [{ ...MODEL_TYPE_ALL_SEARCH_OPTION }];

  source.forEach((item) => {
    const modelType = item?.modelType;
    if (!modelType || optionSet.has(modelType)) {
      return;
    }
    optionSet.add(modelType);
    options.push({
      title: modelType,
      value: modelType,
    });
  });

  return options;
}

export function getModelGroupFormValues(modelGroups = [], modelType) {
  const modelGroup = (modelGroups || []).find(
    (item) => item?.modelType === modelType
  );
  if (!modelGroup) {
    return null;
  }
  return {
    bm: modelGroup.bm || "",
    description: modelGroup.description || "",
  };
}

export function resolveSelectedModelGroup(
  values = {},
  modelGroups = [],
  fallbackParentModelId,
  fallbackModelType
) {
  const matchedGroup = (modelGroups || []).find(
    (item) => item?.modelType === values.modelType
  );
  if (matchedGroup?._id) {
    return matchedGroup;
  }
  if (fallbackParentModelId && fallbackModelType === values.modelType) {
    return {
      _id: fallbackParentModelId,
      modelType: values.modelType,
    };
  }
  return null;
}

export function getModelFormInitialValues(data = {}) {
  data = data || {};
  const logoUrl = getModelLogoUrl(data);
  return {
    ...data,
    modelName:
      getModelDisplayName(data) === "-" ? undefined : getModelDisplayName(data),
    modelLogo: logoUrl ? [{ url: logoUrl }] : [],
    bm: data.bm || data.code || "",
    inputPrice:
      data.inputPrice ?? normalizeModelPriceFormValue(data.promptCoefficientRMB),
    outputPrice:
      data.outputPrice ??
      normalizeModelPriceFormValue(data.completionCoefficientRMB),
    officialInputPrice:
      data.officialInputPrice ?? data.officialPromptCoefficientRMB,
    officialOutputPrice:
      data.officialOutputPrice ?? data.officialCompletionCoefficientRMB,
  };
}

function normalizeModelPriceFormValue(value) {
  if (value === undefined || value === null || value === "") {
    return value;
  }
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) {
    return value;
  }
  return Number((numberValue / MODEL_PRICE_RATIO).toFixed(6));
}

function normalizeSearchText(value) {
  return typeof value === "string" ? value.trim() : value;
}

export function normalizeModelListSearchParams(values = {}) {
  const nextValues = { ...values };
  const modelName = normalizeSearchText(
    nextValues.modelName !== undefined ? nextValues.modelName : nextValues.model
  );
  const modelType = normalizeSearchText(nextValues.modelType);

  nextValues.modelName = modelName || null;
  nextValues.model = modelName || null;
  nextValues.modelType = modelType || null;

  return nextValues;
}

export function buildDeleteModelKeyPayload(record = {}) {
  return {
    parentModelId: record.parentModelId,
    _id: record._id,
  };
}

function normalizeKeyEntityValue(value) {
  return value === undefined || value === null ? "" : String(value);
}

export function buildModelKeyListPayload(modelId) {
  return {
    modelId,
  };
}

export function buildModelKeyEntityPayload(modelId, values = {}, record = {}) {
  const payload = {
    modelId,
    weight: normalizeKeyEntityValue(values.weight),
    endpoint: values.endpoint || "",
    api_key: values.api_key || "",
  };
  const keyIndex = values.index ?? record?.index;
  if (keyIndex !== undefined && keyIndex !== null) {
    payload.index = normalizeKeyEntityValue(keyIndex);
  }
  return payload;
}

export function buildDeleteModelKeyEntityPayload(modelId, record = {}) {
  return {
    modelId,
    index: normalizeKeyEntityValue(record.index),
  };
}

export function normalizeModelPayload(values = {}) {
  values = values || {};
  const logoUrl = Array.isArray(values.modelLogo)
    ? values.modelLogo[0]?.url
    : values.modelLogo;
  const payload = {
    ...values,
    modelLogo: logoUrl || "",
    logoUrl: logoUrl || "",
    bm: values.bm || values.modelType || "CHAT",
  };

  delete payload.chargeRuleDisplay;
  return payload;
}

export function normalizeModelKeyPayload(values = {}) {
  values = values || {};
  const logoUrl = Array.isArray(values.modelLogo)
    ? values.modelLogo[0]?.url
    : values.modelLogo;
  const payload = {
    modelType: values.modelType,
    model: values.model || values.modelName,
    modelLogo: logoUrl || "",
    bm: values.bm || values.modelType || "CHAT",
    description: values.description || "",
    promptCoefficientRMB: normalizeModelPricePayloadValue(
      values.promptCoefficientRMB ?? values.inputPrice
    ),
    completionCoefficientRMB: normalizeModelPricePayloadValue(
      values.completionCoefficientRMB ?? values.outputPrice
    ),
    officialPromptCoefficientRMB:
      values.officialPromptCoefficientRMB ?? values.officialInputPrice,
    officialCompletionCoefficientRMB:
      values.officialCompletionCoefficientRMB ?? values.officialOutputPrice,
    enableStatus: values.enableStatus,
    discount: values.discount,
    discountEn: values.discountEn,
    sort: values.sort,
  };

  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined) {
      delete payload[key];
    }
  });
  return payload;
}

function normalizeModelPricePayloadValue(value) {
  if (value === undefined || value === null || value === "") {
    return value;
  }
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) {
    return value;
  }
  return Math.round(numberValue * MODEL_PRICE_RATIO);
}

export function calculateModelSubsidyPercent(platformPrice, officialPrice) {
  const platformValue = Number(platformPrice);
  const officialValue = Number(officialPrice);
  if (
    !Number.isFinite(platformValue) ||
    !Number.isFinite(officialValue) ||
    officialValue <= 0
  ) {
    return "";
  }
  return ((1 - platformValue / officialValue) * 100).toFixed(2);
}

export function buildModelSubsidyText(platformPrice, officialPrice) {
  const subsidyPercent = calculateModelSubsidyPercent(
    platformPrice,
    officialPrice
  );
  return subsidyPercent ? `${subsidyPercent}%` : "--";
}

function getTokenCountByPrice(price) {
  const value = Number(price);
  if (!value || value <= 0) {
    return "--";
  }
  return Math.floor(1000000 / value / 100);
}

export function buildChargeRuleText(inputPrice, outputPrice) {
  return [
    `输入价格：1单元大模型算力≈${getTokenCountByPrice(
      inputPrice
    )}输入token；
                   1灵能=10单元大模型算力`,
    `输出价格：1单元大模型算力≈${getTokenCountByPrice(
      outputPrice
    )}输出token；
                   1灵能=10单元大模型算力`,
  ].join("\n");
}
